export class SurveyAnswer {
  public id: number;
  public visitorId: number;
  public surveyQuestionId: number;
  public questionOptionId: number;
  public questionAnswer: string;
  public rowStatus: boolean;
  public createdBy: string;
  public createdDate: Date;
  public updatedBy: string;
  public updatedDate: Date;
  public modelAction: number;
}
